import { ReactNode } from 'react'

import SimpleA from '../../components/display/SimpleAnchor'

type ApologiesMessageProps = {
  place: ReactNode
  linkName: string
  linkUrl: string
}

const ApologiesMessage = ({
  place,
  linkName,
  linkUrl,
}: ApologiesMessageProps) => (
  <>
    Riparide is new to {place} and we&apos;re still discovering unique stays and
    adventures. Follow us on Instagram{' '}
    <SimpleA href={linkUrl} target="_blank">
      {linkName}
    </SimpleA>{' '}
    for more inspiration.
  </>
)

const buildApologiesMessage = (filters: GQL_SearchFilters) => {
  const { country, state } = filters

  if (country === 'NZ') {
    return {
      title: 'Hey NZ!',
      body: (
        <ApologiesMessage
          place="New Zealand"
          linkName="@riparide.nz"
          linkUrl="https://www.instagram.com/riparide.nz/"
        />
      ),
    }
  }

  if (country === 'US') {
    switch (state) {
      case 'WA':
        return {
          title: 'Hey there!',
          body: (
            <ApologiesMessage
              place="Washington"
              linkName="@riparide.usa"
              linkUrl="https://www.instagram.com/riparide.usa/"
            />
          ),
        }
      case 'OR':
        return {
          title: 'Hey there!',
          body: (
            <ApologiesMessage
              place="Oregon"
              linkName="@riparide.usa"
              linkUrl="https://www.instagram.com/riparide.usa/"
            />
          ),
        }
      default:
        return undefined
    }
  }

  return undefined
}

export default buildApologiesMessage
